import { Link } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import { RootState } from "src/store/app/store";
import { useAppDispatch, useAppSelector } from "src/store/app/hooks";
import {closeAvatarMenu} from "src/store/features/appbarSlice";
import { useTranslation } from "react-i18next";
import { postLogoutAPI } from "src/store/features/user/login/logoutSlice";
import { loginCheckAPI } from "src/store/features/user/login/loginCheckSlice";
import { preloadRouteForPath } from "src/router/routeLoaders";

function AvatarMenu() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // Redux에서 상태값 가져오기
  const anchorEl = useAppSelector((state: RootState) => state.appbar.anchorEl);
  const isAvatarMenuOpen = Boolean(anchorEl);

  // Avatar Menu 닫기 함수
  const handleAvatarMenuClose = () => {
    dispatch(closeAvatarMenu());
  };

  // 로그아웃 함수
  const handleSignOut = async () => {
    try {
      dispatch(closeAvatarMenu());
      const result = await dispatch(postLogoutAPI());
  
      if (postLogoutAPI.fulfilled.match(result)) {
        dispatch(loginCheckAPI());
        
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  // 화면 렌더링
  return (
    <Menu
      anchorEl={anchorEl}
      id="avatar-menu"
      open={isAvatarMenuOpen}
      onClose={handleAvatarMenuClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <Link onMouseEnter={() => preloadRouteForPath("/myinfo")} onFocus={() => preloadRouteForPath("/myinfo")} to="/myinfo" style={{ textDecoration: "none", color: "inherit" }}>
        <MenuItem onClick={handleAvatarMenuClose} disableRipple sx={{fontSize:"14px"}}>
          <InfoIcon sx={{ marginRight: "10px" , fontSize:"medium"}} />
          {t(`appbar.myinfo`)}
        </MenuItem>
      </Link>
      <Divider sx={{ my: 0.5 }} />
      <Link onMouseEnter={() => preloadRouteForPath("/settings")} onFocus={() => preloadRouteForPath("/settings")} to="/settings" style={{ textDecoration: "none", color: "inherit" }}>
        <MenuItem onClick={handleAvatarMenuClose} disableRipple sx={{fontSize:"14px"}}>
          <SettingsIcon sx={{ marginRight: "10px" , fontSize:"medium"}} />
          {t(`appbar.settings`)}
        </MenuItem>
      </Link>
      <MenuItem onClick={handleSignOut} disableRipple sx={{fontSize:"14px"}}>
        <ExitToAppIcon sx={{ marginRight: "10px" , fontSize:"medium"}} />
        {t(`appbar.signout`)}
      </MenuItem>
    </Menu>
  );
}

export default AvatarMenu;
